/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import React from "react"
import { H2 } from "@carrotfertility/carotene"
import { FormattedMessage } from "react-intl"

const UpdatePhoneNumberHeaderAndCopy = () => (
  <>
    <H2>
      <FormattedMessage defaultMessage="Update your phone number" />
    </H2>
    <Spacer height={0.5} />
    <Body color="black-80">
      <FormattedMessage
        defaultMessage="We need to verify your mobile phone number before we can update it. This info is used to contact you via SMS if
      there's an issue with your card and is never shared with third parties."
      />
    </Body>
    <Spacer height={1.5} />
  </>
)

export { UpdatePhoneNumberHeaderAndCopy }
